<template>
  <div>
    <div class="titileDefinition">奖品统计</div>
    <div class="linerHeight"></div>
    <div class="section-right-content-box">
      <div style="margin: 20px 0px 20px 0px">
        <el-form label-width="10px">
          <el-form-item>
            <span style="margin-right: 20px">统计时间 :</span>
            <el-radio
              v-model="queryForm.evaluateTime"
              @change="timeChange"
              v-for="item in options.evaluateTimeOpt"
              :key="item.value"
              :label="item.value"
              >{{ item.label }}</el-radio
            >
            <div class="my_select_time">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="postForm.startDate"
                type="datetime"
                :placeholder="'选择日期时间'"
                size="small"
                :disabled="queryForm.evaluateTime != 0 || !queryForm.evaluateTime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 120px; font-size: 12px"
                class="time1"
                :clearable="false"
              ></el-date-picker>
              <div
                class="time_to_text"
                :class="{
                  to_text_disabled: queryForm.evaluateTime != 0 || !queryForm.evaluateTime,
                }"
              >
                至
              </div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="postForm.endDate"
                type="datetime"
                :placeholder="'选择日期时间'"
                size="small"
                :disabled="queryForm.evaluateTime != 0 || !queryForm.evaluateTime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 145px; font-size: 12px"
                class="time2"
                :clearable="true"
              ></el-date-picker>
              <i class="el-icon-circle-close date_icon1" @click="clearTimeSendTime()"></i>
              <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
            </div>
            <el-button class="b1" style="margin-left: 20px" @click="queryTable()" v-zoom="{ from: '忠诚度管理-奖品统计', name: '查询' }"
              ><span style="marginleft: 4px">
                <i
                  class="el-icon-search"
                  style="
                    display: inline-block;
                    width: 14px;
                    height: 12px;
                    fontweight: bold;
                    margin-right: 4px;
                  "
                ></i
                >查询</span
              ></el-button
            >
            <el-button class="b2" style="margin-left: 20px" @click="queryOne()"><span style="marginleft: 4px">重置</span></el-button>
          </el-form-item>
        </el-form>
      </div>

      <div style="clear: left" ref="payRemindChart" class="chart" v-loading="loading"></div>

      <div class="exportbutton">
        <div class="exportButtonBox">
          <el-button class="expectBox" @click="exportData">导出</el-button>
        </div>
      </div>
      <div class="section-right-content-box-table" v-loading="loading">
        <div class="table-box">
          <el-table
            ref="multipleTable"
            :data="tableTable"
            tooltip-effect="light"
            :header-cell-style="{ background: '#F8F9FF', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
            style="width: 100%; opacity: 1"
            @selection-change="handleSelectionChange"
          >
            <template slot="empty">
              <div>
                <img class="no_goods_img" src="@/assets/images/default/暂无任何数据.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column prop="statsDate" label="统计日期"> </el-table-column>
            <el-table-column prop="coupon" label="优惠券(张)"></el-table-column>
            <!-- <el-table-column prop="beans" label="京豆"></el-table-column> -->
            <el-table-column prop="goods" label="实物(份)"></el-table-column>
            <el-table-column prop="scores" label="积分"></el-table-column>
            <!-- <el-table-column prop="eCard" label="京东E卡(张)"></el-table-column>
            <el-table-column prop="aqy" label="爱奇艺会员"></el-table-column>
            <el-table-column prop="plus" label="plus会员"></el-table-column> -->
            <el-table-column prop="redPacket" label="红包(元)"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import echarts from "echarts";
import { getChartPrizeStates, getTablePrizeStates } from "@/api/integralCenter/PointActivityAnalyticController";
export default {
  data() {
    return {
      tableData: [],
      multipleSelection: [], // 表格多选
      messageOne: "流量分析",
      messageTwo: "活动数据",
      messageThree: "奖品统计",
      topSelect: 1,
      tabActiveIndex: 1,
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.postForm.startDate) {
            return time.getTime() < new Date(this.postForm.startDate).getTime();
          } else {
          }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.postForm.endDate) {
            return time.getTime() > new Date(this.postForm.endDate).getTime();
          } else {
          }
        },
      },
      //表格数据
      tableTable: [],
      queryForm: {
        evaluateTime: "30",
      },
      postForm: {
        startDate: "",
        endDate: "",
      },
      countTable: [],

      //折线图数据
      myCharts: null,
      tableTotal: [],
      chartEffectDetail: {
        aqy: [], //发放爱奇艺会员数量统计 ,
        beans: [], //发放京豆数量统计 ,
        coupon: [], //发放优惠券数量统计 ,
        eCard: [], //京东E卡
        goods: [], //发放实物数量统计 ,
        plus: [], //发放PLUS会员数量统计 ,
        redPacket: [], //发放红包金额统计 ,
        scores: [], //发放积分数量统计 ,
        statsDate: [], //统计日期
      },
      loading: true,
      //查询条件
      options: {
        evaluateTimeOpt: [
          {
            value: "7",
            label: "近七天",
          },
          {
            value: "15",
            label: "近15天",
          },
          {
            value: "30",
            label: "近30天",
          },
          {
            value: "0",
            label: "自定义",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      changeColor: "globalBG",
    }),
  },
  created() {
    this.buriedPoint(1, "云起互动", "数据分析", "奖品统计");
    this.timeChange(30);
    this.queryTable();
  },
  methods: {
    hugItemBtn(type) {
      this.topSelect = type;
    },
    //查询表格数据
    queryTable() {
      // console.log(this.postForm.startDate);
      // console.log(this.postForm.endDate);
      // let startTime=this.postForm.startDate;
      //  let endTime=this.postForm.endDate;
      this.loading = true;
      getTablePrizeStates({
        startTime: this.postForm.startDate,
        endTime: this.postForm.endDate,
      })
        .then((res) => {
          this.loading = false;
          this.tableTable = res.data;
        })
        .catch((res) => {
          this.$message.error("输入时间错误");
        });

      //折线图数据查询
      getChartPrizeStates({
        startTime: this.postForm.startDate,
        endTime: this.postForm.endDate,
      })
        .then((res) => {
          if (res.data.length == 1 && res.data.length == 0) {
            this.$message.error("折线图时间过短");
          } else if (res.data.length > 1) {
            var dataList = res.data;
            var aqyList = []; //发放爱奇艺会员数量统计
            var beansList = []; //发放京豆数量统计
            var couponList = []; //发放优惠券数量统计
            var eCardList = []; //发放京东E卡统计
            var goodsList = []; //发放实物数量统计
            var plusList = []; //发放PLUS会员数量统计
            var redPacketList = []; //发放红包金额统计
            var scoresList = []; // 发放积分数量统计
            var statsDateList = []; //统计日期

            dataList.forEach((item) => {
              aqyList.push(item.aqy);
              beansList.push(item.beans);
              couponList.push(item.coupon);
              eCardList.push(item.eCard);
              goodsList.push(item.goods);
              plusList.push(item.plus);
              redPacketList.push(item.redPacket);
              scoresList.push(item.scores);
              statsDateList.push(item.statsDate);
            });
            this.chartEffectDetail = {
              aqy: aqyList, //发放爱奇艺会员数量统计
              beans: beansList, //发放京豆数量统计
              coupon: couponList, //发放优惠券数量统计
              eCard: eCardList, //发放京东E卡统计
              goods: goodsList, //发放实物数量统计
              plus: plusList, //发放PLUS会员数量统计
              redPacket: redPacketList, //发放红包金额统计
              scores: scoresList, // 发放积分数量统计
              statsDate: statsDateList, //统计日期
            };
          }
          this.$nextTick(() => {
            this.initChart();
            window.addEventListener("resize", () => {
              this.myCharts.resize();
            });
          });
          console.log(this.chartEffectDetail);
          console.log(this.chartEffectDetail.homePagePv);
          console.log(this.chartEffectDetail.homePageUv);
          console.log(this.chartEffectDetail.incrJoinNumber);
          console.log(this.chartEffectDetail.joinNumber);
          console.log(this.chartEffectDetail.joinTimes);
          console.log(this.chartEffectDetail.perCapitaTimes);
          console.log(this.chartEffectDetail.pv);
          console.log(this.chartEffectDetail.statsDate);
        })
        .catch((res) => {
          this.$message.error("输入时间错误");
        });
    },

    //折线图
    initChart() {
      this.myCharts = echarts.init(this.$refs.payRemindChart);
      this.setOptions(this.chartEffectDetail);
      // console.log(this.chartEffectDetail);
    },
    //折线图事件
    setOptions({ aqy, beans, coupon, eCard, goods, plus, redPacket, scores, statsDate } = {}) {
      let option = {
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: [
            // "发放爱奇艺会员数量统计",
            // "发放京豆数量统计",
            "发放优惠券数量统计",
            // "发放京东E卡统计",
            "发放实物数量统计",
            // "发放PLUS会员数量统计",
            "发放积分数量统计",
            "发放红包金额统计",
          ],
          bottom: -5,
          // left: 60,
          x: "center",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "6%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: statsDate,
        },
        yAxis: {
          type: "value",
          axisLine: {
            //y轴
            show: false,
          },
          axisTick: {
            //y轴刻度线
            show: false,
          },
          splitLine: {
            //网格线
            show: true,
            color: "#999",
          },
        },
        series: [
          // {
          //   name: "发放爱奇艺会员数量统计",
          //   type: "line",
          //   smooth: true,
          //   color: "#7F85E9",
          //   areaStyle: {},
          //   data: aqy,
          // },
          // {
          //   name: "发放京豆数量统计",
          //   type: "line",
          //   smooth: true,
          //   color: "#5882FB",
          //   areaStyle: {},
          //   data: beans,
          // },
          {
            name: "发放优惠券数量统计",
            type: "line",
            smooth: true,
            color: "#FF872F",
            // areaStyle: {},
            data: coupon,
          },
          // {
          //   name: "发放京东E卡统计",
          //   type: "line",
          //   smooth: true,
          //   color: "#FE4D45",
          //   areaStyle: {},
          //   data: eCard,
          // },
          {
            name: "发放实物数量统计",
            type: "line",
            smooth: true,
            color: "#FFC400",
            // areaStyle: {},
            data: goods,
          },
          // {
          //   name: "发放PLUS会员数量统计",
          //   type: "line",
          //   smooth: true,
          //   color: "#FF938E",
          //   areaStyle: {},
          //   data: plus,
          // },
          {
            name: "发放积分数量统计",
            type: "line",
            smooth: true,
            color: "#4CDFC0",
            // areaStyle: {},
            data: scores,
          },
          {
            name: "发放红包金额统计",
            type: "line",
            smooth: true,
            color: "#8693CB",
            // areaStyle: {},
            data: redPacket,
          },
        ],
      };

      this.myCharts.setOption(option);
    },

    // 监听表格多选事件
    handleSelectionChange(val) {
      // console.log(val);
      this.multipleSelection = val;
    },
    //重置
    queryOne() {
      this.queryForm.evaluateTime = "7";
      this.timeChange(30);
      this.queryTable();
    },
    //导出数据
    exportData() {
      let startTime = this.postForm.startDate;
      let endTime = this.postForm.endDate;
      let elem = document.createElement("a");
      elem.style.display = "none";
      let url = `/api/PointActivityAnalyticController/exportTablePrizeStates?startTime=${startTime}&endTime=${endTime}`;
      elem.href = url;
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);
    },
    //查询我的分组
    handleClick(type) {
      this.tabActiveIndex = 2;
      this.topSelect = type;
      this.queryList();
    },
    handleClick2(type) {
      this.tabActiveIndex = 3;
      this.topSelect = type;
      this.queryList();
    },
    handleClick0(type) {
      this.tabActiveIndex = 1;
      this.topSelect = type;
      this.queryList();
    },
    //时间限制
    clearTimeSendTime() {
      this.postForm.startDate = "";
      this.postForm.endDate = "";
    },
    timeChange(type) {
      let self = this;
      let hh = new Date().getHours() < 10 ? "0" + new Date().getHours() : new Date().getHours();
      let mf = new Date().getMinutes() < 10 ? "0" + new Date().getMinutes() : new Date().getMinutes();
      let ss = new Date().getSeconds() < 10 ? "0" + new Date().getSeconds() : new Date().getSeconds();
      console.log(hh);
      console.log(mf);
      console.log(ss);
      const date = [self.getDay(-7, "-"), self.getDay(0, "-")];
      this.mytime = date;
      console.log(date);
      if (type == null) {
        this.postForm.startDate = `${this.mytime[0]} ${hh}:${mf}:${ss}`;
        this.postForm.endDate = `${this.mytime[1]} ${hh}:${mf}:${ss}`;
      } else if (type == 7) {
        this.postForm.startDate = `${this.mytime[0]} ${hh}:${mf}:${ss}`;
        this.postForm.endDate = `${this.mytime[1]} ${hh}:${mf}:${ss}`;
      } else if (type == 15) {
        this.mytime[0] = self.getDay(-15, "-");
        this.mytime[1] = self.getDay(0, "-");
        this.postForm.startDate = `${this.mytime[0]} ${hh}:${mf}:${ss}`;
        this.postForm.endDate = `${this.mytime[1]} ${hh}:${mf}:${ss}`;
      } else if (type == 30) {
        this.mytime[0] = self.getDay(-30, "-");
        this.mytime[1] = self.getDay(0, "-");
        this.postForm.startDate = `${this.mytime[0]} ${hh}:${mf}:${ss}`;
        this.postForm.endDate = `${this.mytime[1]} ${hh}:${mf}:${ss}`;
      } else {
        this.postForm.startDate = "";
        this.postForm.endDate = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.titileDefinition {
  min-width: 1046px;
  height: 57px;
  line-height: 57px;
  padding: 0 20px;
  margin: 20px 20px 0 20px;
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
  font-size: 16px;
  color: #2e3458;
  font-weight: bold;
  background: rgba(255, 255, 255, 1);
  // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
}

.section-right-content-box {
  min-width: 1046px;
  border-bottom: 6px;
  padding: 15px 28px 30px 28px;
  background: rgba(255, 255, 255, 1);
  // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  opacity: 1;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0 20px 20px 20px;
  .tabList {
    display: flex;
    box-sizing: border-box;
    height: 36px;
    line-height: 35px;
    // margin-top: 20px;
    color: #666;
    font-size: 14px;
    margin: 20px 0;
    span {
      margin-right: 3px;
      width: 106px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      vertical-align: middle;
      transform: perspective(1px) translateZ(0);
      box-shadow: 0 0 1px rgba(0, 0, 0, 0);
      border-radius: 2px 2px 0px 0px;
      border: 1px solid #dddddd;
      text-align: center;
    }
    .active {
      position: relative;
      transition: all 0.2s;
      color: #2670fb;
      border-bottom: none;
      &::before {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        width: 100%;
        top: 0;
        height: 2px;
        background: #2670fb;
        border-radius: 6px 6px 0px 0px;
      }
    }
    i {
      flex: 1;
      border-bottom: 1px solid #dddddd;
      margin-left: -3px;
    }
  }
  .b1 {
    width: 98px;
    height: 32px;
    color: #fff;
    border: 1px solid #2670fb;
    background-color: #2670fb;
    &:hover {
      opacity: 0.8;
    }
  }
  .b2 {
    width: 98px;
    height: 32px;
    color: #666666;
    border: 1px solid #dddddd;
    background-color: #fff;
    &:hover {
      color: #2670fb;
      border: 1px solid #2670fb;
      background-color: rgba(38, 112, 251, 0.1);
    }
  }
  .background {
    height: 32px;
    background: rgba(250, 250, 250, 1);
    opacity: 1;
    line-height: 32px;
    padding-left: 12px;
    .title {
      display: inline-block;
      width: 2px;
      height: 14px;
      background: rgba(254, 77, 69, 1);
      opacity: 1;
      border-radius: 3px;
      vertical-align: middle;
    }
    .tips {
      width: 56px;
      height: 20px;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      color: rgba(51, 51, 51, 1);
      opacity: 1;
      vertical-align: middle;
    }
  }
  .exportbutton {
    .exportButtonBox {
      float: right;
      margin: 10px 0;
    }
  }
  .section-right-content-box-table {
    //  margin-top: 10px;
    min-width: 1018px;
    background-color: #fff;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    border-radius: 6px;
    padding: 26px 30px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    opacity: 1;
    .search-box {
      height: 80px !important;
      .timePicker {
        vertical-align: middle;
        margin-right: 10px;
      }
      .button {
        vertical-align: middle;
      }
    }
    .headForm {
      margin-left: -20px;
    }
  }
  .chart {
    // flex: 1;
    height: 600px;
    min-width: 1000px;
  }
}
</style>
